<template>
  <v-container class="why-choose-container">
    <v-card class="elevation-3 rounded-lg pa-4">
      <div class="why-choose-faqs">
        <!-- Why Choose Century Financial Services Section -->
        <h2 class="text-h5 font-weight-bold primary--text mb-4">
          Why Choose Century Financial Services
        </h2>
        <v-expansion-panels flat>
          <!-- Why should I choose Century Financial Services? -->
          <v-expansion-panel>
            <v-expansion-panel-header
              class="text-subtitle-1 font-weight-bold primary--text"
            >
              Why should I choose Century Financial Services for my loan?
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-card-text>
                <p class="body-1 mb-3">
                  At Century Financial Services, we're committed to providing
                  fast, reliable, and affordable financial solutions.
                </p>
                <v-list dense class="flex-wrap">
                  <v-list-item>
                    <v-list-item-icon>
                      <v-icon color="primary">mdi-check-circle</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title class="body-1 text-wrap"
                        ><strong>Quick approvals</strong> - Once your loan is
                        approved, funds are transferred to your bank account
                        swiftly—often within the same business
                        day.</v-list-item-title
                      >
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-icon>
                      <v-icon color="primary">mdi-check-circle</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title class="body-1 text-wrap"
                        ><strong>Easy application</strong> - Applying is simple.
                        You only need to provide basic personal and financial
                        details.</v-list-item-title
                      >
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-icon>
                      <v-icon color="primary">mdi-check-circle</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title class="body-1 text-wrap"
                        ><strong>Affordable repayment</strong> - Enjoy interest
                        discounts when you repay on time, with no fees for early
                        settlement.</v-list-item-title
                      >
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-icon>
                      <v-icon color="primary">mdi-check-circle</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title class="body-1 text-wrap"
                        ><strong>No unnecessary admin</strong> - Transparent
                        terms and no hidden charges.</v-list-item-title
                      >
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-card-text>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <!-- How do I know I can trust Century Financial Services? -->
          <v-expansion-panel>
            <v-expansion-panel-header
              class="text-subtitle-1 font-weight-bold primary--text"
            >
              How do I know I can trust Century Financial Services?
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-card-text>
                <p class="body-1 mb-3">
                  You're in safe hands with Century Financial Services. We are
                  fully compliant with South African regulations and committed
                  to responsible lending.
                </p>
                <v-card outlined class="pa-4 mb-4">
                  <v-row no-gutters>
                    <v-col cols="12" sm="4" class="mb-3 mb-sm-0">
                      <div class="d-flex">
                        <v-icon left color="primary" class="mr-2"
                          >mdi-office-building</v-icon
                        >
                        <div>
                          <div class="caption text-uppercase">Company Name</div>
                          <div class="font-weight-medium">
                            Century Financial Services (Pty) Ltd
                          </div>
                        </div>
                      </div>
                    </v-col>
                    <v-col cols="12" sm="4" class="mb-3 mb-sm-0">
                      <div class="d-flex">
                        <v-icon left color="primary" class="mr-2"
                          >mdi-file-document</v-icon
                        >
                        <div>
                          <div class="caption text-uppercase">
                            Registration Number
                          </div>
                          <div class="font-weight-medium">2023/140135/07</div>
                        </div>
                      </div>
                    </v-col>
                    <v-col cols="12" sm="4">
                      <div class="d-flex">
                        <v-icon left color="primary" class="mr-2"
                          >mdi-certificate</v-icon
                        >
                        <div>
                          <div class="caption text-uppercase">NCR Number</div>
                          <div class="font-weight-medium">NCRCP 20790</div>
                        </div>
                      </div>
                    </v-col>
                  </v-row>
                </v-card>
                <p class="body-1">
                  We operate in accordance with the
                  <strong>National Credit Act</strong>, ensuring that our
                  services are fair, transparent, and in your best financial
                  interest.
                </p>
              </v-card-text>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </div>
    </v-card>
  </v-container>
</template>
<script>
export default {
  name: "WhyChooseComponent",
  data() {
    return {
      // No specific data items needed for this component currently
    };
  },
};
</script>
<style scoped>
.why-choose-container {
  max-width: 900px;
  margin: 0 auto;
  padding-top: 24px;
  padding-bottom: 24px;
}

@media only screen and (max-width: 600px) {
  .body-1 {
    font-size: 14px;
    line-height: 21px;
    letter-spacing: 0.01em;
  }
}
</style>
